import { Text, Title } from "ui/Typography"
import Avatar from "components/common/Avatar"
import { Button, Flex, Skeleton } from "antd"
import GroupProfileTags from "../GroupProfileTags"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import moment from "moment"
import PropTypes from "prop-types"

const ClientIdentity = ({ client, handleEditClick }) => {
  const { last_contacted, client_groups, loading } = client || {}
  const { first_name, last_name } = client?.user || {}
  const { t } = useTranslation()

  return (
    <Skeleton avatar loading={loading} active>
      <Flex gap={16} className={styles.userDetailsWraper} justify="center" align="center">
        <Avatar user={client?.user} className={styles.userImage} />
        <Flex vertical gap={4} className={styles.userDetails}>
          <Button className="justify-start px-0" type="text" onClick={handleEditClick}>
            <Title level={3}>
              {first_name} {last_name}
            </Title>
          </Button>
          {last_contacted && (
            <Text className={styles.lastContacted}>
              {t("client.last_contacted_date")}: {moment(last_contacted)?.format("MMMM DD, YYYY")}
            </Text>
          )}
          <GroupProfileTags className={styles.profileTags} groups={client_groups} />
        </Flex>
      </Flex>
    </Skeleton>
  )
}

ClientIdentity.propTypes = {
  client: PropTypes.object,
  handleEditClick: PropTypes.func
}

export default ClientIdentity
